<template>
  <div class="container">
    <!-- <div class="container-title">
      <span >融媒矩阵</span>
    </div> -->
    <div class="container-video video">
      <div class="video-title">
        <span>{{video1List.name}}</span>
        <span class="con-span" @click="toList(video1List.id)">更多></span>
      </div>
      <div class="video-img">
        <img :src="bk" alt="">
        <div class="play-video">
          <img :src="play[index]" id="play" @click="toPlay()" @mousemove="changImg" @mouseleave="changImg1" alt="">
        </div>
        <div class="img-span">
          <span>{{title}}</span>
        </div>
      </div>
    </div>
    <div class="container-video video">
      <div class="video-title">
        <span>{{video2List.name}}</span>
        <span class="con-span" @click="toList(video2List.id)"
        >更多></span>
      </div>
            <div class="video-img1">
            <div class="item-imgs"
                 v-for="(item,index) in video2List.content"
                 v-if="index<1"
                 :key="index"
                 @click="toDetail(item.id)"
            >
              <img :src="item.thumbnail" alt="" class="new_img">
              <div class="item-span" style="height: 15%">
                <span>{{item.title}}</span>
              </div>
            </div>
              </div>
      </div>
    <div class="container-video video">
      <div class="video-title">
        <!-- <span>{{video3List.name}}</span> -->
         <span>企业招聘</span>
        <span class="con-span"  @click="toList(video3List.id)">更多></span>
      </div>
      <div class="video-img1">
        <!-- <div class="item-imgs"
             v-for="(item,index) in video3List.content"
             v-if="index<1"
             :key="index"
             @click="toDetail(item.id)"
        >
          <img :src="item.thumbnail" alt="" class="new_img">
          <div class="item-span" style="height: 15%">
            <span>{{item.title}}</span>
          </div>
        </div> -->
        <div class="item-imgs" @click="toList(video3List.id)">
          <img :src="zpImg" class="new_img" />
        </div>
      </div>
    </div>

    <div class="cover-container" v-if="showVideo">
      <span class="close"><a @click="showVideo = false">关闭</a></span>
      <div class="video1" style="width: 900px">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :options="playerOptions"
        ></video-player>
      </div>
    </div>
  </div>

</template>

<script>
import play from '@/assets/play.png'
import play1 from '@/assets/play1.png'
import zp from '@/assets/zp.jpg'
export default {
  name: "Video",
  data(){
    return{
      bk:'',
      play:[play,play1],
      zpImg: zp,
      index:0,
      video1List: {},
      video2List: {},
      video3List: {},
      playerOptions: {
        // videojs options
        autoplay: true,
        muted: false,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          src: ''
        }],
        poster: '/static/imgs/logos.jpg'
      },
      showVideo: false,
      title:""
    }
  },
  props:{
    getVList:{
      type:Array,
    }
  },
  watch:{
    getVList:function (){
      this.video1List=this.getVList[0]
      this.video2List=this.getVList[1]
      this.video3List=this.getVList[2]
      this.bk=this.video1List.content[0].thumbnail
      this.title=this.video1List.content[0].title
    }
  },
  methods:{
    toDetail (id) {
      this.$router.push(`/content/${id}`)
    },
    toList (id) {
      this.$router.push(`/news/${id}`)
    },
    toPlay(){
      // 获取新闻详情
      this.playerOptions.sources[0].src = this.video1List.content[0].video_url
      this.playerOptions.poster = this.bk
      this.showVideo = true
    },
    changImg(){
      this.index=1
    },
    changImg1(){
      this.index=0
    }
  },
}
</script>

<style scoped>
.container-title{
  line-height: 30px;
  border-bottom: 1px solid #d0d0d0;
  color: #2574c2;
  font-weight: bold;
}
.video-title{
  position: relative;
  margin: 10px;
  line-height: 20px;
  border-bottom: 1px solid #d0d0d0;
  color: #000000;
  font-size: 13px;
  height: 21px;
}
.con-span{
  position: absolute;
  right: 0;
  cursor: pointer;
}
.container-video{
  padding: 10px;
  box-shadow: 1px 1px 4px #ccc;
  height: 188px;

  &:nth-child(n+2) {
    margin-top: 10px;
  }
}
.video-img img{
  width: 100%;
  height: 130px;
}
.video-img {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  overflow: hidden;
}
/*@keyframes an1 {*/
/*  0% {top:120px;}*/
/*  50% {top:60px}*/
/*  100% {top:0}*/
/*}*/
.img-span{
  position: absolute;
  width: 100%;
  height: 20px;
  background-color: rgba(0,0,0,0.6);
  bottom: 0;
  font-size: 14px;
  color: white;
  text-align: center;
  line-height: 20px;
}
.video-img:hover .play-video{
 top:65px;
  transition:all 1s;
}
.video-img:hover .img-span{
  bottom:-22px;
  transition:all 1s;
}
.play-video{
  position: absolute;
  top: 110px;
  width: 100%;
  height: 50%;
  background-color: rgba(0,0,0,0.3);
}
#play{
  position: absolute;
  left: 40%;
  top: 20%;
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.video-img1{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
}
/*.video-img1 .item-img1:nth-child(1){*/
/*  margin-bottom: 4px;*/
/*}*/
/*.video-img1 .item-img1:nth-child(2){*/
/*  margin-bottom: 4px;*/
/*}*/
.item-img1{
  position: relative;
  width: 48%;
  margin-bottom: 2px;
  text-align: center;
  cursor: pointer;
}
.item-img1 img{
  width: 100%;
  height: 70px;
}

.container{
  padding: 10px;
  background-color: white;
  height: 652px;
  overflow: hidden;
}

.item-img1 span{
  font-size: 10px;
  color: white;
}
.item-img1 span:hover{
  font-size: 10px;
  color: red;
}
.item-span{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 28%;
  background-color: rgba(0,0,0,0.5);
}

.cover-container {
  background: rgba(0,0,0,0.5);
  top:0;
  right:0;
  left:0;
  bottom:0;
  position:fixed;
  z-index: 999;
}

.close {
  color: #fff;
  position: fixed;
  top: 8%;
  right: 10%;
  cursor: pointer;
}

.close:hover {
  text-decoration: underline;
}

.video1 {
  /*width: 900px;*/
  margin: 0 auto;
}
.video1 >>>.video-js {
  width: 914px;
  height: 500px;
  border: none;
  position: absolute;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
}

.video1 >>> .vjs-big-play-button {
  width: 100px;
  height: 78px;
  line-height: 76px;
  border-radius: 50px;
  font-size: 50px;
  border: none;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  transform: translateY(-50%);
}
.item-imgs{
  text-align: center;
  position: relative;
  width: 232px;
  height: 150px;
}
.new_img{
  width: 100%;
  height: 150px;
}
.item-imgs span{
  font-size: 14px;
  color: white;
}
.item-imgs span:hover{
  font-size: 14px;
  color: red;
  cursor: pointer;
}


</style>



// WEBPACK FOOTER //
// src/components/Video.vue